export function isImageType (type:string) {
  const imageFileTypes = [
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/gif',
  ]
  return imageFileTypes.includes(type);
}

export async function getImageMeta (url:string): Promise<HTMLImageElement> {
  let img = new Image();
  return await new Promise((resolve) => {
    img.onload = () => resolve(img);
    img.src = url;
  });
}

export function formatBytes(bytes:number, decimals:number) {
  if(bytes <= 0) return '0 Byte';
  let k = 1000;
  let dm = decimals;
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let i = Math.floor(Math.log(bytes) / Math.log(k));
  let size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  return size <= 0 ? '0 MB' : size + ' ' + sizes[i];
}

export function getPathAfterBuild(context, subpath) {
  let imported;
  try {
    imported = context(subpath);
  } catch(error) {
    console.error(error);
    return;
  }
  const isModule = typeof imported === 'object' && imported != null;
  return isModule ? imported.default : imported;
}